// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qsg2yshTvWhejz0CXndCi","cancelBtn":"_2_WZ3GwPV8wGlaMPJovv1","icon":"_35Clg3K4YNX4WQ1ddPI8mG","saveBtn":"_20N0Z646PVhSDbTTv2RRsY"};